import script from "./CCDiscord.vue?vue&type=script&setup=true&lang=js"
export * from "./CCDiscord.vue?vue&type=script&setup=true&lang=js"

import "./CCDiscord.vue?vue&type=style&index=0&id=2f0b05e4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f0b05e4"]])

export default __exports__